<template>
  <div class="hello page-roster">
    <div class="topOperation">
      <div class="top-left">
        <div>
          <ShowNavHead />
        </div>
        <div class="flex">
          <div class="exactDate flex aic">
            <div class="flname">归属月份:&nbsp;&nbsp;&nbsp;&nbsp;</div>
            <div class="block">
              <el-date-picker v-model="listQuery.belongMonthstart" type="month" :picker-options="pickerOptions" value-format="yyyy-MM" placeholder="开始月份">
              </el-date-picker>
              <span style="margin:0 5px;display:inline-block;">-</span>
              <el-date-picker v-model="listQuery.belongMonthend" type="month" :picker-options="pickerOptionEnd" value-format="yyyy-MM" placeholder="结束月份">
              </el-date-picker>
            </div>
          </div>
          <button class="exportButton" style="margin-left:5px;" @click="getImprtInfo">搜索</button>
        </div>
      </div>
      <div class="top-right" style="margin-right:30px">
        <el-button type="text" @click="dropDownScreen">
          <img src="../../assets/employee/images/screen.png" />
          <span>筛选</span>
        </el-button>
      </div>

      <!-- 筛选下拉框 -->
      <div class="dropDownScreen" v-show="showDropScreen==1">
        <div class="inputs">
          <div class="formScreenInput">
            <div>账户名称</div>
            <el-select v-model="listQuery.straccountname" filterable remote reserve-keyword placeholder="请输入账户名称" @focus="remoteFocus('straccountname')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>团队长</div>
            <el-select v-model="listQuery.strleader" filterable remote reserve-keyword placeholder="请输入团队长" @focus="remoteFocus('strleader')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>业绩归属人</div>
            <el-select v-model="listQuery.strdirector" filterable remote reserve-keyword placeholder="请输入业绩归属人" @focus="remoteFocus('strdirector')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>区域</div>
            <el-select v-model="listQuery.strarea" filterable remote reserve-keyword placeholder="请输入区域" @focus="remoteFocus('strarea')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>部门</div>
            <el-select v-model="listQuery.strdepartment" filterable remote reserve-keyword placeholder="请输入部门" @focus="remoteFocus('strdepartment')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-select v-model="listQuery.strdepartment" filterable placeholder="请选择">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select> -->
          </div>
          <div class="formScreenInput">
            <div>服务中心</div>
            <el-select v-model="listQuery.strSrvCent" filterable remote reserve-keyword placeholder="请输入服务中心" @focus="remoteFocus('strSrvCent')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>项目名称</div>
            <el-select v-model="listQuery.strObjName" filterable remote reserve-keyword placeholder="请输入项目名称" @focus="remoteFocus('strObjName')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>收入名称</div>
            <el-select v-model="listQuery.strIncomeName" filterable remote reserve-keyword placeholder="请输入收入名称" @focus="remoteFocus('strIncomeName')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>支出名称</div>
            <el-select v-model="listQuery.strExpendName" filterable remote reserve-keyword placeholder="请输入支出名称" @focus="remoteFocus('strExpendName')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="formScreenInput">
            <div>收支归类</div>
            <el-select v-model="listQuery.strClass" filterable remote reserve-keyword placeholder="请输入收支归类" @focus="remoteFocus('strClass')" :remote-method="remoteMethod" :loading="searchLoading">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
            <!-- <el-autocomplete
              class="inline-input"
              v-model="listQuery.strClass"
              :fetch-suggestions="querySearch"
              @focus="remoteFocus('strClass')"
              placeholder="请输入收支归类"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete> -->
          </div>
        </div>
        <div class="drop-footer">
          <button class="clear" style="margin-right:10px" @click="clear()">清空</button>
          <button class="search" @click="getImprtInfo()">搜索</button>
          <button class="clear" @click="showDropScreen=-1">关闭</button>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>财务</el-breadcrumb-item>
          <el-breadcrumb-item>财务数据源</el-breadcrumb-item>
          <el-breadcrumb-item>项目列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="customerRosterTable">
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane label="财务数据源列表" name="0"></el-tab-pane>
          <el-tab-pane label="自动采集设置" name="1"></el-tab-pane>
          <el-tab-pane label="自动刷新利润表设置" name="2"></el-tab-pane>
          <!-- <el-tab-pane label="财务数据源月报" name="second"></el-tab-pane>
          <el-tab-pane label="财务数据源年报" name="third"></el-tab-pane> -->
        </el-tabs>
        <div class="dlt_btn">
          <el-button type="warning" plain size="mini" @click="gather">采集系统数据</el-button>
          <el-button type="primary" plain size="mini" @click="importInfo">导入</el-button>
          <el-button type="success" plain size="mini" @click="exportHandle" :loading="exportLoading" v-if="(tableData.length>0&&!isNull(tableData))">导出</el-button>
          <el-button type="danger" plain size="mini" @click="deleteHandle" style="margin-left:0">清除导入数据</el-button>
        </div>
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading" border style="width: 99%" :lazy="true">
          <!-- <el-table-column align="center" type="selection" width="40"></el-table-column> -->
          <template v-for="(item,index) in tableTitle">
            <el-table-column fit show-overflow-tooltip :prop="item.StrColumId" :label="item.StrColumName" :key="index" :width="item.StrColumName=='备注' ? 380 : (item.StrColumName=='NO'? 60 : (item.StrColumName=='姓名'? 100 : 180)) " align="center" :fixed="item.StrColumName=='项目名称' || item.StrColumName=='姓名'">
              <template slot-scope="scope">
                <span v-if="((item.StrColumName != '收入名称')&&(item.StrColumName.indexOf('收入')!=-1)) || item.StrColumName.indexOf('金')!=-1 || ((item.StrColumName != '支出名称')&&(item.StrColumName.indexOf('支出')!=-1)) || item.StrColumName.indexOf('结余')!=-1 || item.StrColumName.indexOf('商保')!=-1 || item.StrColumName.indexOf('险')!=-1 || item.StrColumName.indexOf('个人承担')!=-1 || item.StrColumName.indexOf('利润')!=-1">
                  <!-- {{isNull2(scope.row[item.StrColumId]) ? '-' : Number(scope.row[item.StrColumId]).toLocaleString(undefined,{minimumFractionDigits:2})}} -->
                  {{isNull2(scope.row[item.StrColumId]) ? '-' : scope.row[item.StrColumId]}}
                </span>
                <span v-else-if="item.StrColumName=='插入时间'||item.StrColumName.indexOf('日期')!=-1">{{isNull(scope.row[item.StrColumId]) ? '' : scope.row[item.StrColumId].substring(0, 10)}}</span>
                <span v-else-if="item.StrColumName=='身份证号码'">{{scope.row[item.StrColumId]}}</span>
                <span v-else>{{scope.row[item.StrColumId]}}</span>
              </template>
            </el-table-column>
          </template>
        </el-table>
        <div class="block" v-if="Number(totalcount)>0">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.currpage" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100]" :page-size="listQuery.pagecount" layout="total,sizes,prev,pager, next, jumper" :total="totalcount"></el-pagination>
        </div>
      </div>
    </div>

    <div class="dialog">
      <div class="tagArea">
        <!-- 导入 -->
        <el-dialog :visible.sync="dialogVisible5" width="700px">
          <div class="diaTitle">导入数据 至 {{exportName}}</div>
          <el-steps :active="active" finish-status="success" class="steps-box">
            <el-step title="基础信息"></el-step>
            <el-step title="上传导入文件"></el-step>
            <el-step title="导入处理"></el-step>
          </el-steps>
          <div v-if="active==0" style="margin-top:15px;padding-bottom:15px;">
            <div class="flex">
              <div>
                <div class="impTitle">导入表格:</div>
                <div class="storageInput" style="margin:0 20px 0 0">
                  <el-select v-model="tabName" slot="prepend" placeholder="请选择" filterable @change="selectTab">
                    <el-option v-for="(item, index) in tableList" :key="index" :label="item.StrTableName" :value="{value:item.StrTableId,label:item.StrTableName}"></el-option>
                  </el-select>
                </div>
              </div>
              <div style="margin-left:10px">
                <div>导入模板下载:</div>
                <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;margin-top:10px">下载模板</el-button>
              </div>
            </div>
            <div class="flex impdata">
              <div class="bookkeepingMonth">
                <div class="impTitle">归属月份:</div>
                <el-date-picker v-model="belongMonthDialog" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM" @change="selectMonthHandle"></el-date-picker>
              </div>
            </div>
          </div>
          <div v-if="active==1" style="margin-top:15px;padding-bottom:15px;">
            <div class="note-txt">
              <p style="font-weight:bold;">上传文件说明：</p>
              <p>1. 支持文件后缀 xls、xlsx文件。
              </p>
              <p>2. 请将要上传的内容放在第一个sheet中。
              </p>
              <p>3. 请不要加密模板文件，将导致错误。
              </p>
              <p>4. 请不要上传带宏的文件，将导致错误。
              </p>
              <p>5. 请不要过多的使用格式，如背景色和边框，将可能导致超时。
              </p>
              <p>6. 导入后只会保留Excel中的数据及通过公式计算后的值，设置的文字颜色等样式、合并的单元格、以及计算公式本身都不会被保留。</p>
            </div>
            <div style="margin-top:10px">请选择导入文件（xls/xlsx格式）:</div>
            <div class="form-item" style="justify-content: space-between;">
              <div class="file-box">
                <input readonly style="width: 368px;height:32px" id="applyLicense" type="text" v-model="ExcelSrc.fileName" autocomplete="off">
                <input id="fileInput" type="file" name="file" accept=".xlsx,.xls" @change="importf(this)" ref="upload">
                <label for="fileInput" class="file-btn">上传</label>
              </div>
              <el-button type="text" @click="downLoadHandle" style="margin-left:15px;height:30px;">下载模板</el-button>
            </div>
            <!-- 提示 -->
            <p style="color:red;" v-if="isError">{{errorTxt}}</p>
            <div class="reimpArea">
              <div style="margin-top:10px">
                <!-- <el-checkbox v-model="isReset" @change="selectReimp">是否覆盖导入</el-checkbox> -->
                <!-- <el-radio v-model="reimpLab" label="0" border size="small" @change="selectReimp">否</el-radio>
                <el-radio v-model="reimpLab" label="1" border size="small" @change="selectReimp">是</el-radio> -->
              </div>
            </div>
          </div>
          <div v-if="active==2" style="margin-top:15px;padding-bottom:15px;">
            <div class="result-box">
              <p><i class="el-icon-success" style="color: #409EFF;margin-right:5px"></i>导入数据正在处理中，导入结果请在’导入记录‘中查看。</p>
            </div>
          </div>
          <div style="display:flex;justify-content:flex-end;-webkit-justify-content:flex-end;padding-bottom: 30px;">
            <el-button size="small" @click="dialogVisible5 = false" v-if="active==0">取消</el-button>
            <el-button size="small" @click="prevSteps" v-if="active>0 && active<=1">上一步</el-button>
            <el-button type="primary" size="small" @click="nextSteps" v-if="active<1">下一步</el-button>
            <el-tooltip effect="dark" content="未上传文件不能提交" :disabled="!isUploadSuccess" placement="top">
              <div style="display:inline-block;margin-left:10px">
                <el-button type="success" size="small" @click="lastSteps" element-loading-text="此操作可能耗费较长时间，请等待..." element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)" v-loading.fullscreen.lock="fullscreenLoading" v-if="active==1" :disabled="isUploadSuccess">提交</el-button>
              </div>
            </el-tooltip>
            <el-button type="primary" size="small" @click="backHandle" v-if="active==2">确认并返回</el-button>
            <el-button size="small" @click="resultHandle" v-if="active==2">查看导入结果</el-button>
          </div>
        </el-dialog>
        <!-- 删除 -->
        <el-dialog :visible.sync="delDialog" width="600px">
          <div class="diaTitle">删除数据</div>
          <el-form :model="dltQuery" label-width="100px" class="demo-ruleForm">
            <el-form-item label="归属月份:" prop="belongMonth">
              <el-date-picker v-model="dltQuery.belongMonth" :picker-options="pickerOptions" type="month" placeholder="选择月" value-format="yyyy-MM"></el-date-picker>
            </el-form-item>
          </el-form>
          <span slot="footer" class="dialog-footer">
            <el-button size="small" style="margin-right:15px" @click="delDialog = false">取消</el-button>
            <el-popconfirm :title="'确认要删除当月所有数据吗?'" icon="el-icon-info" icon-color="red" @confirm="confirmDel">
              <el-button size="small" slot="reference" type="danger">确认删除</el-button>
            </el-popconfirm>
          </span>
        </el-dialog>
      </div>
    </div>
    <el-dialog title="采集系统数据" :visible.sync="showGather" width="500px">
      <el-form :model="gatherForm" ref="gatherForm" :rules="gatherRule" label-width="100">
        <el-form-item label="采集月:" prop="StartTime">
          <el-date-picker v-model="gatherForm.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width:300px">
          </el-date-picker>
        </el-form-item>
        <!-- <el-form-item label="采集方式:" prop="way">
              <el-select v-model="gatherForm.way" size="small" filterable clearable placeholder="" style="width: 300px;">
                <el-option value="自动">
                </el-option>
                <el-option value="手工">
                </el-option>
              </el-select>
            </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showGather = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" size="small" @click="confirmGather" :loading="isBtnLoading">确 认</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common"
  import FUN from "../../fun"
  import moment from 'moment'
  import {
    parseTime
  } from '../../utils' //格式化时间格式
  import checkPermission from '@/utils/permission' // 权限判断函数
  import {
    mode
  } from "mathjs"
  export default {
    name: "financialSource",
    data() {
      return {
        delDialog: false,
        // 删除参数
        dltQuery: {
          strObjName: '',
          tableid: 'XZ_emp_FnncDataSource',
          bookingRealMonth: '',
          belongMonth: ''
        },
        //列表参数
        listQuery: {
          pagecount: 10,
          currpage: 1,
          straccountname: '', // 账户名
          strleader: '', // 团队长
          strdirector: '', // 负责人 业绩归属人
          strarea: '', //区域
          strdepartment: '', // 部门
          strSrvCent: '', //服务中心
          strObjName: '', // 项目
          strIncomeName: '', // 收入
          strExpendName: '', // 支出
          strClass: '', // 分类
          belongMonthstart: parseTime(new Date(), '{y}-{m}'), //归属月 开始
          belongMonthend: parseTime(new Date(), '{y}-{m}') // 归属月 结束
        },
        //导出参数
        exportQuery: {
          pagecount: 100000000,
          currpage: 1,
          straccountname: '', // 账户名
          strleader: '', // 团队长
          strdirector: '', // 负责人
          strarea: '', //区域
          strdepartment: '', // 部门
          strSrvCent: '', //服务中心
          strObjName: '', // 项目
          strIncomeName: '', // 收入
          strExpendName: '', // 支出
          strClass: '', // 分类
          belongMonthstart: '', //归属月 开始
          belongMonthend: '' // 归属月 结束
        },
        rowdate: {
          bookingRealMonth: '',
          bookDate: ''
        },
        belongMonthDialog: '',
        // 导出按钮加载状态
        exportLoading: false,
        // 导入弹框
        dialogVisible5: false,
        // 导入步骤
        active: 0,
        // 导入到的项目名称
        exportName: '',
        // 选择导入的表格名称
        tabName: '',
        tabId: '',
        // 导入的表格列表
        tableList: [],
        // 导入的表头是否有错误
        isError: false,
        // 导入的表头错误提示
        errorTxt: '',
        // 导入excel生成的路径
        excelpath: '',
        // 上传excel是否成功-判断下一步按钮是否禁用
        isUploadSuccess: true,
        fullscreenLoading: false,
        showGather: false,
        isBtnLoading: false,
        gatherForm: {
          AttrMonth: '',
          // way: '手动',
          UserId: Cookies.get("userid-b"),
        },
        gatherRule: {
          StartTime: {
            required: true,
            message: '请选择开始时间',
            trigger: 'change'
          },
          EndTime: {
            required: true,
            message: '请选择结束时间',
            trigger: 'change'
          },
          way: {
            required: true,
            message: '请选择采集方式',
            trigger: 'change'
          },
        },
        // 禁用日期范围
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        pickerOptionEnd: {
          disabledDate(time) {
            return time.getTime() > Date.now()
          }
        },
        strTableId: "XZ_emp_FnncDataSource",
        // 表格高度
        tableHeight: 0,
        apartmentList: [],
        listLoading: false,
        // 姓名
        empname: "",
        // 身份证
        idn: "",
        tableclumn: [],
        // 表头内容
        tableTitle: [],
        // 项目名称
        custname: "",
        // 筛选项目名称
        custname2: "",
        ExcelSrc: {
          value: "",
          check: false,
          fileName: ""
        },
        fields: [],
        totalcount: null,
        //下拉筛选
        showDropScreen: -1,
        tableData: [],
        currFileData: [],
        // 是否下载模板
        isFnnSourceDownload: false,
        tablePath: this.$store.state.EMP.tablePath,
        // 筛选参数
        searchQuery: {
          pagecount: 100000,
          currpage: 1,
          type: '',
          keyword: ''
        },
        resultList: [],
        searchLoading: false,
        // 筛选里的搜索列表
        options: [],
        activeName: '0',
        // 按钮权限参数
        butQuery: {
          path: '/financialSource',
          powerEnName: 'financeManage'
        },
        permissionLists: []
      }
    },
    created() {
      this.butQuery.roletype = localStorage.loginRoletype
      this.getButtonPower()
      this.strTableId = 'XZ_emp_FnncDataSource'
      if (window.localStorage.getItem('isFnnSourceDownload')) {
        this.calDaysBetween(window.localStorage.getItem('isFnnSourceDownload'), 'source')
      }
      this.pickerOptionEnd.disabledDate = (time) => {
        let disabledTime = (Date.now() < time.getTime()) || (time.getTime() < new Date(this.listQuery.belongMonthstart).getTime())
        // console.log('disabledTime',disabledTime)
        return disabledTime
      }
      this.calHeight()
      // 固定字段
      this.getImportFiledList()
      if (!this.isNull(this.$route.query.strleader)) {
        this.listQuery.strleader = this.$route.query.strleader
        this.listQuery.strSrvCent = this.$route.query.strSrvCent
        this.listQuery.strObjName = this.$route.query.strObjName
        this.listQuery.strdirector = this.$route.query.strdirector
        this.listQuery.belongMonthstart = this.$route.query.belongMonthstart
        this.listQuery.belongMonthend = this.$route.query.belongMonthend
        // console.log('llt',this.listQuery)
        this.getImprtInfo()
      } else {
        // this.listQuery.belongMonthstart = parseTime(new Date(), '{y}-{m}')
        // this.listQuery.belongMonthend = parseTime(new Date(), '{y}-{m}')
        this.listQuery.belongMonthstart = moment().subtract(1, 'month').format('YYYY-MM')
        this.listQuery.belongMonthend = moment().subtract(1, 'month').format('YYYY-MM')
        this.getImprtInfo()
      }
    },
    methods: {
      checkPermission,
      handleClick() {
        if (this.activeName != '0') {
          this.$router.push({
            path: '/gatherSet',
            query: {
              activeName: this.activeName
            }
          })
        }
        // console.log(tab, event);
        // if(tab.name == 'second'){
        //   this.$router.push({path:'/financialSummary', query: { type: 'month' }})
        // }
        // if(tab.name == 'third'){
        //    this.$router.push({path:'/financialSummary', query: { type: 'year' }})
        // }
      },
      //删除弹窗
      deleteHandle() {
        // this.dltQuery = {
        //   strObjName: '',
        //   tableid: 'XZ_emp_FnncDataSource',
        //   bookingRealMonth:'',
        //   belongMonth: ''
        // }
        this.delDialog = true;
      },
      //确认删除
      confirmDel() {
        if (!this.dltQuery.belongMonth) {
          this.$message.warning('请选择归属日期')
          return false
        }
        // console.log('jjj', this.dltQuery)
        xz.delfnncuserimport(this.dltQuery).then(res => {
          if (res) {
            this.$message.success("删除成功！")
            this.getImprtInfo()
            this.delDialog = false
          } else {
            this.$message.fileid("删除失败！")
            this.delDialog = false
          }
        })
      },
      // 获取按钮权限
      getButtonPower() {
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      // 下拉选择表格
      selectTab(d) {
        this.tabId = d.value;
        this.tabName = d.label;
        this.exportName = '财务数据源'
        // console.log("d", d);
      },
      //导入
      importInfo() {
        this.tableList = [{
          StrTableId: "XZ_emp_FnncDataSource",
          StrTableName: "财务数据源"
        }]
        this.tabName = '财务数据源';
        this.tabId = 'XZ_emp_FnncDataSource';
        this.dialogVisible5 = true;
        this.errorTxt = ''
        this.ExcelSrc = {
          value: "",
          check: false,
          fileName: ""
        }
        this.active = 0;
      },
      selectMonthHandle(date) {
        console.log("date", date);
      },
      //导入-确认返回
      backHandle() {
        this.dialogVisible5 = false
        this.getCustomerList()
      },
      //查看导入结果
      resultHandle() {
        this.dialogVisible5 = false
        this.$router.push({
          path: "/employee-fnnchis",
        })
      },
      //上一步导入
      prevSteps() {
        this.active -= 1
      },
      //下一步导入
      nextSteps() {
        if (this.active == 0) {
          if (this.tabName == '') {
            this.$message({
              message: "请选择导入模板",
              type: "warning"
            });
            this.active = 0
            return false
          }
          // console.log('isfs', this.rowdate)
          if (!this.isFnnSourceDownload) {
            this.$message({
              message: "请先下载导入模板，下一步导入请使用新的模板导入",
              type: "warning",
              duration: 5000
            });
            return false
          }
          if (this.isNull2(this.belongMonthDialog)) {
            this.$message.warning('请选择归属月份')
            return false
          }
        }
        this.active += 1
      },
      //提交导入
      async lastSteps() {
        if (this.ExcelSrc.value == '') {
          this.isUploadSuccess = true
          this.$message({
            message: "请选择文件上传",
            type: "warning"
          });
          this.active = 1
          return false
        } else {
          //检查表头是否正确
          let checkData = {
            excelpath: this.excelpath,
            tableid: this.tabId,
            fileid: this.tabName
          }
          this.fullscreenLoading = true;
          xz.chkfinanceimpdatatbtype(checkData).then(res => {
            // console.log('checkData',res)
            let resultTxt = res
            // console.log('resultTxt',this.isNull(res))
            if (this.isNull(res)) {
              this.isError = false
              this.isUploadSuccess = false;
              let Edata = {};
              Edata = {
                instname: '',
                tableid: this.tabId,
                reimp: 1, // 是否覆盖
                excelpath: this.excelpath,
                impexcel: this.ExcelSrc.fileName,
                servusrname: '',
                servcentname: '杰博',
                custname: this.tabName,
                fileid: this.tabName,
                bookingRealMonth: '',
                belongMonth: this.belongMonthDialog
              }
              console.log('edata', Edata)
              xz.financeAnlysisExcelInf(Edata).then(res => {
                if (res) {
                  this.active = 2
                } else {
                  this.$message('导入错误');
                }
                this.fullscreenLoading = false;
                // this.isUploadSuccess = true
              })
            } else {
              this.isError = true
              this.active = 1
              this.isUploadSuccess = true
              this.errorTxt = resultTxt
              //导入操作，如果第一次导入某个文件会触发导入操作，但是第二次导入重复该文件，不会触发操作
              //清空input file值
              var file = document.getElementById("fileInput");
              file.value = "";
              this.fullscreenLoading = false;
            }
          })
        }
      },
      //文件读取
      async importf() {
        const fileInput = this.$refs.upload;
        this.excelpath = ''
        FUN.returnExcelSrc(fileInput).then(src => {
          if (src) {
            // console.log('src0o0', src)
            this.isFileSuccess = true
            this.$set(this.ExcelSrc, "value", src.src);
            this.$set(this.ExcelSrc, "check", false);
            this.$set(this.ExcelSrc, "fileName", fileInput.files[0].name);
            // console.log('srccc', this.ExcelSrc)
            //上传excel
            const excelFile = FUN.base64ToFile(this.ExcelSrc.value, this.ExcelSrc.fileName);
            const formData = new FormData();
            formData.append("pagename", 'empexcel');
            formData.append("action", 'save');
            formData.append("userid", Cookies.get("userid-b"));
            formData.append("entid", Cookies.get("userid-b"));
            formData.append("excel", excelFile, this.ExcelSrc.fileName);
            // console.log('formData', formData)
            xz.uploadCert(formData).then(res => {
              // console.log('formData', res)
              if (this.isNull(res) || res == false) {
                this.$message('上传Excel失败!')
                this.isUploadSuccess = true
              } else {
                this.errorTxt = ''
                this.excelpath = res;
                this.isUploadSuccess = false
                this.$refs['upload'].value = null;
              }
            });
          } else {
            this.$message('上传Excel失败!')
          }
        })
      },
      //下载模板
      downLoadHandle() {
        let tabId = 'output_' + this.tabId;
        xz.getfinanceinputmode(this.tabName, tabId).then(res => {
          if (res.msg) {
            this.isFnnSourceDownload = true;
            window.localStorage.setItem('isFnnSourceDownload', new Date())
            var d = res.msg.data.StrOutPath
            d = d.replace("\"", "").replace("\"", "")
            var path = this.tablePath + d
            const aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          } else {
            this.$message.warning('还没有导入模板，请联系管理员上传导入模板')
          }
        })
      },
      //计算相差天数
      calDaysBetween(date, type) {
        let startDate = Date.parse(date);
        let endDate = Date.parse(new Date());
        let days = (endDate - startDate) / (1 * 24 * 60 * 60 * 1000);
        if (type == 'source') {
          days > 7 ? this.isFnnSourceDownload = false : this.isFnnSourceDownload = true;
        }
      },
      // input 输入建议
      async querySearch(queryString, cb) {
        this.searchQuery.keyword = queryString
        await this.getSearchList()
        let result = this.resultList
        let results = queryString ? result.filter(this.createFilter(queryString)) : result;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      remoteFocus(type) {
        this.searchQuery.type = type
      },
      async remoteMethod(query) {
        this.searchQuery.keyword = query
        await this.getSearchList()
        if (query !== '') {
          this.searchLoading = true;
          setTimeout(() => {
            this.searchLoading = false;
          }, 300);
        } else {
          this.options = [];
        }
      },
      //获取表格高度
      calHeight() {
        this.tableHeight = Number(document.documentElement.clientHeight);
        console.log('height', this.tableHeight)
      },
      //翻页
      handleCurrentChange(val) {
        this.listQuery.currpage = Number(val);
        this.getImprtInfo();
      },
      //改变列表加载数量
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
        this.listQuery.currpage = 1
        this.listQuery.pagecount = Number(val)
        this.getImprtInfo()
      },
      //清空
      clear() {
        this.listQuery.straccountname = '';
        this.listQuery.strleader = '';
        this.listQuery.strdirector = '';
        this.listQuery.strarea = '';
        this.listQuery.strdepartment = '';
        this.listQuery.strSrvCent = '';
        this.listQuery.strObjName = '';
        this.listQuery.strIncomeName = '';
        this.listQuery.strExpendName = '';
        this.listQuery.strClass = '';
        this.listQuery.belongMonthstart = parseTime(new Date(), '{y}-{m}');
        this.listQuery.belongMonthstart = parseTime(new Date(), '{y}-{m}');
      },
      //获取所有字段信息
      async getImportFiledList() {
        const data = {
          pagecount: 100000,
          currpage: 1,
          tablename: "",
          coluname: "",
          strisfixed: 'all', //strisfixed=1 固定字段 strisfixed=0 自定义拓展字段  all所有
          strTableId: this.strTableId
        };
        this.fields = []
        xz.getfinanceempcolumninf(data).then(res => {
          this.tableTitle = res.data;
          // console.log('固定导出字段',res)
          if (res && res.data.length > 0) {
            for (let index = 0; index < res.data.length; index++) {
              const elementRes = res.data[index];
              this.fields.push({
                name: elementRes.StrColumName,
                colname: elementRes.StrColumId
              })
            }
            // console.log('ss',this.currFileData)
            this.fields = []
            for (let index = 0; index < this.currFileData.length; index++) {
              const elementData = this.currFileData[index];
              this.fields.push(elementData.name)
            }
            // console.log('ss',this.fields)
          } else {
            this.tableTitle = []
          }
        }).catch(e => {
          console.log(e)
        })
      },
      //判断是否为空(包含0)或1970
      isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == '1900/01/01' || o == '1900-01-01T00:00:00' || o == '1900-01-01';
      },
      isNull2(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o === '' || o == 'null' || o == []
      },
      //去重
      unique(arr) {
        const resList = new Map();
        return arr.filter((arr) => !resList.has(arr.name) && resList.set(arr.name, 1));
      },
      //导出
      exportHandle() {
        this.exportQuery.straccountname = this.listQuery.straccountname
        this.exportQuery.strleader = this.listQuery.strleader
        this.exportQuery.strdirector = this.listQuery.strdirector
        this.exportQuery.strarea = this.listQuery.strarea
        this.exportQuery.strdepartment = this.listQuery.strdepartment
        this.exportQuery.strSrvCent = this.listQuery.strSrvCent
        this.exportQuery.strObjName = this.listQuery.strObjName
        this.exportQuery.strIncomeName = this.listQuery.strIncomeName
        this.exportQuery.strExpendName = this.listQuery.strExpendName
        this.exportQuery.strClass = this.listQuery.strClass
        this.exportQuery.belongMonthend = this.listQuery.belongMonthend
        this.exportQuery.belongMonthstart = this.listQuery.belongMonthstart
        if (this.isNull(this.listQuery.belongMonthstart) || this.isNull(this.listQuery.belongMonthend)) {
          this.$message({
            showClose: true,
            message: "请选择归属日期",
            type: "warning"
          });
          return false
        } else {
          this.exportLoading = true
          xz.financeSourceData(this.exportQuery).then(res => {
            // console.log('process', res)
            if (res.status == 'ok') {
              this.$router.push({
                path: "/employee-fnnchis",
                query: {
                  showPage: 1,
                  isActive: 1,
                  custname: res.msg,
                  //qStstus=1时查看最后一条导出记录
                  qStstus: 1
                }
              })
            } else {
              this.$message({
                message: "导出错误，请稍后再试",
                type: "error"
              });
            }
            this.exportLoading = false
          })
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      // 筛选条件
      getSearchList() {
        let searchSelList = []
        this.resultList = []
        this.options = []
        xz.getScreenData(this.searchQuery).then(res => {
          // console.log('sss',res)
          if (!this.isNull2(res.msg)) {
            for (let i = 0; i < res.msg.length; i++) {
              const elements = res.msg[i];
              searchSelList.push({
                value: elements.Keyword,
                label: elements.Keyword
              })
            }
          }
          this.resultList = searchSelList
          this.options = searchSelList
          // console.log('wwssw', this.resultList)
        }).catch(e => {
          console.log(e)
        })
      },
      //获取花名册信息
      async getImprtInfo() {
        this.listLoading = true
        xz.getFinanceSourceData(this.listQuery).then(res => {
          // console.log('jj', res)
          if (res.msg && res.msg.length > 0) {
            res.msg.forEach(l => {
              if (!this.isNull2(l.StrIdCard) && l.StrIdCard.indexOf('-') > -1) {
                let arr = l.StrIdCard.split('-')
                l["StrIdCard"] = arr[0];
              }
            });
            this.tableData = res.msg;
            this.totalcount = parseInt(res.totalcount);
          } else {
            this.tableData = [];
            this.totalcount = 0
          }
          this.listLoading = false
          this.showDropScreen = -1;
        }).catch(e => {
          console.log(e)
        })
      },
      gather() {
        this.gatherForm = {
          AttrMonth: '',
          way: '手动',
          UserId: Cookies.get("userid-b")
        }
        this.showGather = true;
      },
      confirmGather() {
        this.$refs.gatherForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.FinancialDataSourcesSystem(this.gatherForm).then(res => {
              if (res.status == 'ok') {
                this.$message.success('数据源采集启动成功');
                this.isBtnLoading = false;
                this.showGather = false;
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .el-tabs--top {
    width: 99%;
    background-color: #fff;
  }

  .page-roster .search {
    height: 32px;
    padding: 5px 15px;
    margin-right: 10px;
    border-radius: 5px;
    background-color: #ebfaf5;
    border: 1px solid #62d2b4;
    color: #19bd92;
  }

  .historyFiled {
    margin-top: 20px;
  }

  .historyFiled .el-radio-group {
    display: inline-block !important;
    margin-right: 10px;
    margin-top: 10px;
  }

  .result-box {
    padding: 15px 10px;
    border-radius: 5px;
    background-color: rgba(103, 194, 58, 0.1);
  }

  .file-box {
    position: relative;
  }

  :focus {
    outline: 0;
  }

  .top-right {
    display: flex;
    align-items: center;
  }

  .top-right .el-button--text {
    padding: 7px 10px;
    border: solid 1px #19bd92;
    font-size: 12px;
    color: #19bd92;
    border-radius: 4px;
    background-color: #fff;
  }

  .top-right .el-button--text img {
    vertical-align: sub;
  }

  .form-item {
    width: 100%;
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #333333;
    margin-bottom: 20px;
  }

  .form-item label {
    width: 56px;
    text-align: right;
  }

  .form-item span {
    color: #ff3228;
  }

  .form-item input {
    width: 400px;
    height: 40px;
    line-height: 40px;
    border: 1px solid #cccccc;
    padding-left: 14px;
    box-sizing: border-box;
    margin-top: 10px;
  }

  /* 这是原生的input框，给他透明隐藏，然后定位让文件上传的按钮覆盖它 */
  #fileInput {
    width: 120px;
    margin-left: 8px;
    filter: Alpha(opacity=0);
    -moz-opacity: 0;
    opacity: 0;
    position: absolute;
    right: 37px;
    z-index: 2;
  }

  /* 这是主要的，文件上传按钮的样式 */
  .file-btn {
    display: inline-block;
    width: 54px;
    height: 30px;
    background: #fff;
    border: 1px solid #ccc;
    /* border-radius:2px; */
    text-align: center !important;
    line-height: 32px;
    color: #333333;
    /* position: relative;
  top: 5px;
  left: 0; */
    margin-left: 8px;
  }

  /* 单行文字截断，展示文件名的input框用的 */
  #applyLicense {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .selectCell {
    display: flex;
  }

  .lineTitle {
    line-height: 48px;
  }

  .page-roster .dlt_btn {
    display: flex;
    justify-content: flex-end;
    background: #fff;
    padding: 10px 0 10px 0;
    width: 99%;
  }

  .dlt_btn .el-button--mini {
    margin-right: 10px;
  }

  .dlt_btn .el-button--success.is-plain {
    margin-left: 0;
  }
</style>


<style>
  .customerRosterTable .el-table td {
    padding: 8px 0;
  }

  .customerRosterTable .el-table th {
    padding: 12px 0;
  }

  .el-popper[x-placement^="bottom"] {
    margin-top: 5px;
  }

  .screenInput .el-input {
    width: 70%;
    margin-left: 5px;
  }

  .searchArea {
    margin-left: 20px;
    display: flex;
    flex-direction: row;
    position: relative;
  }

  .searchArea .el-select .el-input {
    height: 30px;
    width: 130px;
    border-right: none;
  }

  .searchArea .input-with-select .el-input-group__prepend {
    background-color: #fff;
  }

  .input-with-select {
    width: 430px;
  }

  .searchArea .el-input__inner {
    height: 30px;
    line-height: 30px;
  }

  .searchArea .el-input__icon {
    line-height: 30px;
  }

  .drop-downMenu .el-dropdown .el-dropdown-link {
    cursor: pointer;
  }

  .direction .el-button {
    padding: 8px;
  }

  .dialog .el-dialog__header {
    padding: 0;
  }

  .dialog .el-dialog__body {
    padding: 20px 20px 0 20px;
  }

  .formScreenInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .formScreenInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .editInput .el-input__inner {
    height: 32px;
    line-height: 32px;
    width: 180px;
    margin-top: 10px;
  }

  .editInput .el-input__icon {
    margin-top: 10px;
    height: 32px;
    line-height: 32px;
  }

  .dialog .inputs {
    flex-wrap: wrap;
  }

  .dialog .el-drawer__body {
    overflow-y: scroll;
  }

  .fieldBox .el-checkbox__label {
    width: 120px !important;
    margin-bottom: 10px;
  }

  .storageInput .el-input--small .el-input__inner {
    width: 368px;
    height: 32px;
  }

  .storageInput .el-input--small {
    width: 360px;
  }

  .storageArea .upload-demo {
    height: 32px;
  }

  .storageArea .el-button--primary {
    background-color: #fff;
    color: #000;
    border-color: #ccc;
  }

  .el-button--primary:focus,
  .el-button--primary:hover {
    color: #409eff;
    border-color: #c6e2ff;
    background-color: #ecf5ff;
  }

  .storageArea .el-button {
    padding: 9px 15px;
  }

  .el-drawer__body span:focus {
    outline: 0 !important;
  }

  .dialog .el-tabs--border-card>.el-tabs__content {
    max-height: 200px;
    overflow-y: scroll;
  }

  .dialog .el-card__body {
    max-height: 208px;
    overflow-y: scroll;
  }

  .tagArea .el-tag+.el-tag {
    margin-left: 10px;
  }

  .tagArea .el-checkbox_input.is-focus .el-checkbox_inner {
    border-color: #19bd92;
  }

  .tagArea .el-checkbox__input.is-checked .el-checkbox__inner,
  .tagArea .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #19bd92;
    border-color: #19bd92;
  }

  .tagArea .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #19bd92;
  }

  .tagArea .el-checkbox__inner:hover {
    border-color: #19bd92;
  }

  .tagArea .el-tag--plain.el-tag--success {
    color: #19bd92;
  }

  .tagArea .el-tabs--border-card>.el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #19bd92;
  }

  .tagArea .el-tabs--border-card>.el-tabs__header .el-tabs__item.is-active {
    color: #19bd92;
  }

  .tableEditInput .el-input__inner {
    height: 25px;
    line-height: 25px;
    text-align: center;
    padding: 0;
    font-size: 13px;
  }

  .tableEditInput .el-input__icon {
    line-height: 25px;
  }

  .el-select-dropdown__item.selected {
    color: #19bd92 !important;
  }

  .historyFiled .el-radio-group {
    display: flex;
  }

  .exactDate .el-input__inner {
    width: 100%;
    height: 34px;
    line-height: 34px;
  }

  .exactDate .el-input__icon,
  .exactDate .el-date-editor .el-range-separator {
    line-height: 28px;
  }

  .block .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 160px;
  }
</style>